import React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI'
// hooks
import { useFormsLinking } from 'hooks/risks'
import { useMobileScroll } from 'hooks/useMobileScroll'
// view components
import Search from './components/Search'
import RisksHeader from './components/RiskHeader'
import RiskViewFilters from './components/RiskContainer/components/Filters'
import RisksInfinityList from './components/RisksInfinityList'
import ImportedRiskModal from 'components/Modals/ImportedRiskModal'
import RiskViewFilterDrawer from 'components/Modals/RiskViewFilterModal'
// containers
import RiskTemplateAPI from 'containers/Risks/RiskTemplate/Edit/layers/API'
// components
import RiskContainer from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer'
import RiskViewButtons from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskViewButtons'
// types
import { IRisk, IRiskView } from 'types/graphql'
// views
import { Container, RisksContainerWrapper } from './views'

interface Props {
  risks: IRisk[]
  editRisk: (risk: IRisk) => () => void
  loadMore?: (page: number) => Promise<void>
  riskView?: IRiskView
  isLoading: boolean
  deleteRisk: (id: string) => () => Promise<void>
  totalCount?: number
  isScheduled: boolean
  isRelatedForm?: boolean
  riskTemplateId: string
  isInfiniteLoader?: boolean
}

const RisksContainer: React.FC<Props> = ({
  risks,
  loadMore,
  riskView,
  editRisk,
  isLoading,
  totalCount,
  deleteRisk,
  isScheduled,
  isRelatedForm,
  riskTemplateId,
  isInfiniteLoader
}) => {
  const { isFormView } = useFormsLinking()

  const scrollRef = useMobileScroll()

  return (
    <RiskTemplateAPI riskView={riskView} riskTemplateId={riskTemplateId}>
      {!isRelatedForm && (
        <>
          <RiskViewButtons riskView={riskView} />
          {isFormView && <Search />}
          <RiskViewFilters />
        </>
      )}
      <RisksContainerWrapper ref={scrollRef}>
        {isLoading ? (
          <LoaderWithOverlay isLoading={isLoading} height='100%' />
        ) : (
          <>
            {isInfiniteLoader ? (
              <RisksInfinityList
                risks={risks}
                loadMore={loadMore}
                editRisk={editRisk}
                isLoading={isLoading}
                totalCount={totalCount}
                deleteRisk={deleteRisk}
                isScheduled={isScheduled}
              />
            ) : (
              <>
                <RisksHeader isScheduled={isScheduled} />
                <Container className='riskViewContainer'>
                  {risks.map((risk) => (
                    <RiskContainer
                      risk={risk}
                      key={risk.id}
                      isScheduled={isScheduled}
                      editRisk={editRisk(risk)}
                      deleteRisk={deleteRisk(risk.id)}
                    />
                  ))}
                </Container>
              </>
            )}
          </>
        )}

        <ImportedRiskModal />
        <RiskViewFilterDrawer />
      </RisksContainerWrapper>
    </RiskTemplateAPI>
  )
}

export default RisksContainer
